
import {ServerProdApi} from '../../../src/group-cloud/network/ServerBizApi';

export const Mod_Account_Types = {
    HEAD_QUARTER: 1,    // 总部
    CLIENT: 2,          // 客户
    STORE: 3,           // 门店
}

export class Mod_Roles {

    public static async loadRoleInfo(roleId) {

        let url = 'auth_center/yooz/role/role_auth_list';
        let formData =  {
            role_id: roleId,
        };
        let response = await ServerProdApi.send(url, formData);
        return response.result;

    }


    public static async saveRole(data) {

        let formData;

        formData    = {
            group_id: data.user_type,
            rolename: data.role_name,
        };

        let url = 'auth_center/yooz/role/add';
        if (data.role_id > 0) {
            url = 'auth_center/yooz/role/update';
            formData.role_id = data.role_id;
        }

        let response = await ServerProdApi.send(url, formData);
        return response.result;

    }

    public static async getRolesMap(groupId = 0) {

        let url = 'rbacRole_list';
        let formData;
        formData =  {};
        if (groupId > 0) {
            formData.groupId = groupId;
        }
        let response = await ServerProdApi.send(url, formData);

        let map = {};
        let idx, _key;

        //修改返回

        for(idx = 0; idx < response.result.length; idx++) {
            _key = response.result[idx].id;
            map[_key] = response.result[idx].rolename;

        }

        return map;

    }


    public static async getList(groupId = 0) {

        let url = 'rbacRole_list';
        let formData;
        formData =  {};
        if (groupId > 0) {
            formData.groupId = groupId;
        }
        let response = await ServerProdApi.send(url, formData);

        //修改返回
        return response.result;

    }

    public static async getListPage(page = 1, groupId = 0) {

        let url = 'auth_center/yooz/role/role_list_page';
        let formData;
        formData =  {
            page: page,
            page_num: 20,
        };
        if (groupId > 0) {
            formData.group_id = groupId;
        }
        let response = await ServerProdApi.send(url, formData);

        return response.result;

    }



    public static async getRoleMenus(roleId) {

        let url = 'auth_center/yooz/role/role_auth_list';
        let formData =  {
            role_id: roleId,
        };
        let response = await ServerProdApi.send(url, formData);

        let menuIds = [];

        if (response.result && response.result.menu_list) {
            menuIds     = response.result.menu_list;
        }

        return menuIds;

    }

    public static async getMenus(type) {

        let url = 'auth_center/yooz/menu/list';
        let formData =  {
            group_id: type
        };
        let response = await ServerProdApi.send(url, formData);

        let idx, tree = [];

        if (response.result && response.result.length) {
            tree    = this.buildMenuTree(response.result, 'menu_name', 1);
        }

        return tree;

    }

    public static markCheckedTree(tree, menuIds) {

        let idx, ref, ret = [];
        let cache = {};

        for (idx = 0; idx < menuIds.length; idx++) {
            cache[menuIds[idx]] = 1;
        }

        for (idx = 0; idx < tree.length; idx++) {

            if (cache[ tree[idx].id ]) {
                tree[idx].checked = true;
            }

            if (tree[idx].children && tree[idx].children.length) {
                this.markCheckedTree(tree[idx].children, menuIds);
            }

        }

    }

    public static makeWhMap(list) {

        // console.log(['makeWhMap', list]);

        let idx;

        let ret = {};

        let ref;

        for (idx = 0; idx < list.length; idx++) {

            ref = list[idx].wsId;
            ret[ ref ] = list[idx].wsName;

        }

        return ret;

    }

    public static buildMenuTreeWms(list, with_all = 0) {

        let titleField = '';

        let idx;

        let ret = [];

        let ref;

        for (idx = 0; idx < list.length; idx++) {

            ref = {
                id: list[idx].wsId,
                title: list[idx].wsName,
                wsCode: list[idx].wsCode,
                wsName: list[idx].wsName,
                expanded: true,
                checked: false,
                children: []
            };

            if (list[idx].children && list[idx].children.length) {
                ref.children = this.buildMenuTreeWms(list[idx].children);
            }

            ret.push(ref);

        }

        let finalRet = [];

        if (with_all && ret.length) {

            finalRet[0] = {
                id: 0,
                title: '全部',
                expanded: true,
                checked: false,
                children: ret,
            };

        } else {
            finalRet = ret;
        }



        return finalRet;

    }

    public static buildMenuTree(list, titleField = 'menu_name', with_all = 0) {

        let idx;

        let ret = [];

        let ref;

        for (idx = 0; idx < list.length; idx++) {

            ref = {
                id: list[idx].id,
                title: list[idx][titleField],
                expanded: true,
                checked: false,
                children: []
            };

            if (list[idx].children && list[idx].children.length) {
                ref.children = this.buildMenuTree(list[idx].children, titleField);
            }

            ret.push(ref);

        }

        let finalRet = [];

        if (with_all && ret.length) {

            finalRet[0] = {
                id: 0,
                title: '全部',
                expanded: true,
                checked: false,
                children: ret,
            };

        } else {
            finalRet = ret;
        }



        return finalRet;

    }


    public static async bindRoleMenus(roleId, MenuIds) {
        let url = 'auth_center/yooz/role/auth_menu';
        let formData =  {
            role_id: roleId,
            menu_id: MenuIds,
        };
        let ret = 0;
        let response = await ServerProdApi.send(url, formData);
        if (response.succ) {
            ret = 1;
        }
        return ret;
    }

    public static async deleteUser(uid) {
        let url = 'auth_center/yooz/role/delete';
        let formData =  {
            role_id: uid,
        };
        let ret = 0;
        let response = await ServerProdApi.send(url, formData);
        if (response.succ) {
            ret = 1;
            return ret;
        }else{
          return response;
        }
    }


}


